import { Mail } from "lucide-react";
import {
  gql,
  InternalEmailLogOrderByColumn,
  InternalEmailLogsFilterField,
} from "types";
import { FieldType, InternalResourceConfig } from "../lib/internal-resources";

const GET_EMAIL_LOG_LIST = gql(/* GraphQL */ `
  query InternalEmailLogList(
    $pagination: Pagination
    $filters: InternalEmailLogsFiltersExpression
    $orderBy: InternalEmailLogOrderByInput
  ) {
    internalEmailLogList(
      pagination: $pagination
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      list {
        id
        to
        from
        bcc
        subject
        template
        body
        createdAt
      }
    }
  }
`);

export const emailLogResourceConfig: InternalResourceConfig = {
  resourceName: "email-log",
  displayNameKey: "apps.admin.internalResources.emailLog.title",
  basePath: "/internal/data/email-log",

  listQuery: GET_EMAIL_LOG_LIST,
  listQueryName: "internalEmailLogList",

  fields: [
    {
      key: "to",
      labelKey: "apps.admin.internalResources.emailLog.columns.to",
      type: FieldType.String,
      sortKey: InternalEmailLogOrderByColumn.To,
      width: 220,
    },
    {
      key: "subject",
      labelKey: "apps.admin.internalResources.emailLog.columns.subject",
      type: FieldType.String,
      width: 300,
    },
    {
      key: "template",
      labelKey: "apps.admin.internalResources.emailLog.columns.template",
      type: FieldType.String,
      sortKey: InternalEmailLogOrderByColumn.Template,
      width: 250,
    },
    {
      key: "from",
      labelKey: "apps.admin.internalResources.emailLog.columns.from",
      type: FieldType.String,
      width: 180,
    },
    {
      key: "bcc",
      labelKey: "apps.admin.internalResources.emailLog.columns.bcc",
      type: FieldType.String,
      width: 180,
    },
    {
      key: "body",
      labelKey: "apps.admin.internalResources.emailLog.columns.body",
      type: FieldType.JSON,
      width: { min: 100, grow: 1 },
    },
    {
      key: "createdAt",
      labelKey: "apps.admin.internalResources.emailLog.columns.createdAt",
      type: FieldType.DateTime,
      sortKey: InternalEmailLogOrderByColumn.CreatedAt,
      width: 160,
    },
  ],

  list: {
    defaultSort: {
      column: InternalEmailLogOrderByColumn.CreatedAt,
      direction: "desc",
    },
    searchFields: [
      InternalEmailLogsFilterField.To,
      InternalEmailLogsFilterField.Subject,
      InternalEmailLogsFilterField.Template,
    ],
  },

  navigation: {
    icon: <Mail size={16} />,
    order: 5,
  },
};
